import useTranslate from 'hooks/useTranslate';
import React from 'react'
import {BsArrowRightShort, BsCheckCircle} from 'react-icons/bs';
import {  MdErrorOutline} from 'react-icons/md';
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react';
import { useRequest } from 'hooks/useRequest';
import { dataLayerPush } from 'utils/Datalayer';
import auth from 'utils/Auth';

const OrderDetailIframe = () => {
    const [searchParams]= useSearchParams()
    const [request] = useRequest()
    const { t} = useTranslate()
    let error = searchParams.get('error')
    let orderId = searchParams.get('orderId')
    let iframe = searchParams.get('iframe') || true
    //iframe => true - false 
    const getPostArray = (orderResult) => {
      const mappedArray = orderResult?.attributes?.length > 0 ? orderResult?.attributes?.map(attribute => {
        return {
          affilication: "Tavuk Dünyası",
          item_brand: "Tavuk Dünyası",
          item_list_name: "Listeleme Sayfası",
          quantity: 1,
          item_variant: 'Ek Ürün',
          item_id: attribute?.productAttributeId,
          price: attribute?.price || 0,
          discount: 0,
          item_category: attribute?.name,
          item_name: attribute?.valueName,
  
        }
      }) : []
      return mappedArray
    }
    useEffect(() => {
      if(!orderId) return

      request(`/Order/${orderId}`, {
        method: 'GET',
        headers: {
          RestaurantId : auth?.getUserChoises()?.restaurantId,
          DeliveryType : auth?.getUserChoises()?.deliveryType,
          NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
          RegionId : auth?.getUserChoises()?.regionId,
        },
      }).then((res) => { 
        if (res?.data?.ok) {
          const orderNumber = res?.data?.result?.orderNumber;
          const purchaseEventKey = `purchase_sent_${orderNumber}`;
          
          // LocalStorage'da bu sipariş için event gönderilmiş mi kontrol et
          const isPurchaseEventSent = localStorage.getItem(purchaseEventKey);
          
          if (!isPurchaseEventSent) {
            const postArray = res?.data?.result?.orderItems?.map((item) => {
              const productAttributes = item?.attributes
              const breadSelection = productAttributes?.find((a) => a?.name?.includes("Ekmek"))?.values?.find((a) => a?.isPreSelected)?.name
              const saladSelection = productAttributes?.find((a) => a?.name?.includes("Salata"))?.values?.find((a) => a?.isPreSelected)?.name
              const promotionSelection = productAttributes?.find((a) => a?.name?.includes("Promosyon"))?.values?.find((a) => a?.isPreSelected)?.name
              if(item?.attributes?.length > 0){
                return [
                  ...[{
                    item_name: item?.productName,
                    affilication: "Tavuk Dünyası",
                    discount: item?.discountAmount,
                    item_variant:(item?.categories?.[0]?.value.includes('İçecek')||item?.categories?.[0]?.value.includes('Tatlı') || item?.categories?.[0]?.value.includes('Başlangıç') || item?.categories?.[0]?.value.includes('Salata')) ? 'Ek Ürün' : 'Ana Ürün',
                    index: 0,
                    item_brand: "Tavuk Dünyası",
                    item_list_name: "Listeleme Sayfası",
                    bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
                    salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
                    promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
                    price: item?.price,
                    quantity: item?.quantity,
                    item_id: item?.productId,
                    item_category: item?.categories?.[0]?.value,
                    item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
                    item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
                }],
                  ...getPostArray(item)
                ]
              }
              return [ {
                item_name: item?.productName,
                affilication: "Tavuk Dünyası",
                discount: item?.discountAmount,
                item_variant:(item?.categories?.[0]?.value.includes('İçecek')||item?.categories?.[0]?.value.includes('Tatlı') || item?.categories?.[0]?.value.includes('Başlangıç') || item?.categories?.[0]?.value.includes('Salata')) ? 'Ek Ürün' : 'Ana Ürün',
                index: 0,
                item_brand: "Tavuk Dünyası",
                item_list_name: "Listeleme Sayfası",
                bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
                salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
                promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
                price: item?.price,
                quantity: item?.quantity,
                item_id: item?.productId,
                item_category: item?.categories?.[0]?.value,
                item_category2: item?.categories?.[1]?.value ? item?.categories?.[1]?.value : "",
                item_category3: item?.categories?.[2]?.value ? item?.categories?.[2]?.value: "",
            }]
            })
            const mergedArray = [].concat(...postArray);
            dataLayerPush({ ecommerce: null });
            dataLayerPush({
              event:"purchase",
              ecommerce: {
              item_list_name: "Listeleme Sayfası",
              currency: "TRY",
              transaction_id: orderNumber,
              value: res?.data?.result?.orderTotal,
              items: mergedArray
              }
            })
            
            // Purchase event gönderildi, localStorage'a kaydet
            localStorage.setItem(purchaseEventKey, 'true');
          }
        }
      })
    }, [orderId])

  return (
    <div className='orderIframeDetail' style={{position: iframe == 'true' ?'fixed':'unset',minHeight: iframe == 'true'?'unset':'60vh'}}>
        <div>
            {
               !orderId ? (
                <div className='orderIframeDetail-error'>
                    <MdErrorOutline size={80} color='#CD2B31' className='animated-icon'/>
                   <div>{error  ||  t('paymentError')} </div> 
                   <button onClick={()=> window.top.location = `/odeme`}>{t('backToPaymentPage')} <BsArrowRightShort size={26}/></button>
                </div> 
               ) : (
                <div className='orderIframeDetail-success'>
                        <BsCheckCircle size={70} color='#30A46C' className='animated-icon' />
                        <div>{t('yourOrderCompleted')}</div>  
                        <button onClick={()=> window.top.location = `/siparis/${orderId}?newOrder=${true}`}>{t('orderDetail')} <BsArrowRightShort size={26}/></button>
                </div>
               )
            }
        </div>
    </div>
  )
}

export default OrderDetailIframe